/* drehmer-frame v11 (main-product-bundle / template framed-bundle).
   Real frames on the product page. Every frame style that has a kit in snippets/drehmer-frame-kits.liquid
   is drawn as a CSS 9-slice (border-image, repeat: round) OUTSIDE the painting, covering the rabbet
   (0.25 in) of its edge, at the true moulding width:
     thickness px = displayed painting width px × moulding_in ÷ painting width in inches.
   The framed piece is scaled to fit the box the painting had, so the page never jumps.
   Standard sizes / unlocked custom ratios: the frame wraps the crop area and the rest of the image is clipped.
   The section hands over the selection with DrehmerFrame.bind(); a style without a kit keeps the section's
   old overlay. Chrome floors border-image widths to whole CSS px, so each frame is laid out F times larger
   and scaled back down (sub-pixel exact). Decorative only: every node added here is aria-hidden. */
(function () {
  'use strict';
  if (window.DrehmerFrame) return;

  var RABBET = 0.25;
  var kits = null;         /* frame name -> kit (legacy "styles" map and catalog names) */
  var catalog = null;      /* B2B catalog, in menu order ("frames") */
  var extras = {};         /* top-level extras of the kits JSON (wrap_thumb_url, unframed_thumb_url) */
  var bySlug = {};
  var ctx = null;
  var queued = false;
  var lastDims = null;
  var ready = {};          /* kit url -> true once the image is decoded */
  var loaded = {};         /* kit url -> the decoded Image (for the rail colour) */
  var ro = null;
  var io = null;

  function drawable(k) { return !!(k && k.url && k.slice && +k.moulding_in > 0); }
  function readKits() {
    if (kits) return kits;
    kits = {};
    var el = document.querySelector('script[data-drehmer-frame-kits]');
    if (!el) return kits;
    try {
      var j = JSON.parse(el.textContent);
      if (j && +j.rabbet_in > 0) RABBET = +j.rabbet_in;
      if (j) extras = j;
      if (j && Array.isArray(j.frames)) {
        catalog = [];
        j.frames.forEach(function (f) {
          if (!f || !f.slug || !f.name) return;
          if (!(+f.moulding_in > 0) && +f.width_cm > 0) f.moulding_in = +f.width_cm / 2.54;
          f.moulding_in = +f.moulding_in;
          f.name = String(f.name).trim();
          catalog.push(f);
          bySlug[f.slug] = f;
          if (drawable(f)) kits[f.name] = f;
        });
        if (!catalog.length) catalog = null;
      }
      var st = (j && j.styles) || {};
      Object.keys(st).forEach(function (name) {
        var k = st[name];
        if (!drawable(k) || kits[name.trim()]) return;
        k.moulding_in = +k.moulding_in;
        kits[name.trim()] = k;
      });
    } catch (e) { kits = {}; catalog = null; }
    return kits;
  }
  function kitFor(name) { return name ? (readKits()[String(name).trim()] || null) : null; }
  function kitForCard(card) {
    if (!card) return null;
    readKits();
    var f = bySlug[card.getAttribute('data-frame-style-slug') || ''];
    if (f) return drawable(f) ? f : null;
    return kitFor(card.getAttribute('data-frame-name'));
  }
  /* slices in % of the image, so a CDN-resized copy of the kit slices the same */
  function sliceOf(k) {
    var s = k.slice, w = +k.w, h = +k.h;
    if (!(w > 0 && h > 0)) return s.top + ' ' + s.right + ' ' + s.bottom + ' ' + s.left;
    var p = function (v, d) { return (v / d * 100).toFixed(4) + '%'; };
    return p(s.top, h) + ' ' + p(s.right, w) + ' ' + p(s.bottom, h) + ' ' + p(s.left, w);
  }
  /* the Shopify CDN resizes theme assets (?width=) and serves WebP/AVIF: ask for ~1.5× the rail pixels
     this frame needs on this screen, in a few fixed widths so the cache is shared */
  var BUCKETS = [150, 300, 600, 1200];
  function kitSrc(k, t) {
    var w = +k.w, sl = Math.max(k.slice.top, k.slice.left);
    if (!(w > 0 && sl > 0) || !/\/cdn\/shop\/|cdn\.shopify\.com/.test(k.url)) return k.url;
    var need = w * t * (window.devicePixelRatio || 1) * 1.5 / sl, W = 0;
    for (var i = 0; i < BUCKETS.length; i++) if (BUCKETS[i] >= need) { W = BUCKETS[i]; break; }
    if (!W || W >= w) return k.url;
    var at = function (b) { return k.url + (k.url.indexOf('?') < 0 ? '?' : '&') + 'width=' + b; };
    /* a sharper copy already decoded wins: changing size never waits for a smaller download */
    for (var j = i; j < BUCKETS.length && BUCKETS[j] < w; j++) if (ready[at(BUCKETS[j])] === true) return at(BUCKETS[j]);
    if (ready[k.url] === true) return k.url;
    return ready[at(W)] === 'error' ? k.url : at(W);
  }

  /* The 9 pieces of a border-image are drawn one by one; where a corner meets a rail at a fractional device
     pixel both edge pixels are part-covered and the page shows through as a hairline. A ring in the rail's own
     average colour under the frame (inset box-shadow, CSS) hides it. Same-origin CDN image, so the canvas is
     readable; if not, no ring (as before). */
  function railColour(k, im) {
    if (k.__rgb !== undefined) return;
    k.__rgb = null;
    try {
      var W = im.naturalWidth, H = im.naturalHeight, sx = k.slice.left / (+k.w || W), sy = k.slice.top / (+k.h || H);
      var x0 = Math.ceil(W * sx) + 2, x1 = Math.floor(W * (1 - sx)) - 2, rh = Math.max(1, Math.floor(H * sy) - 1);
      if (x1 - x0 < 4) return;
      var c = document.createElement('canvas'); c.width = x1 - x0; c.height = rh;
      var g = c.getContext('2d'); g.drawImage(im, x0, 0, x1 - x0, rh, 0, 0, x1 - x0, rh);
      var d = g.getImageData(0, 0, x1 - x0, rh).data, r = 0, gr = 0, b = 0, n = 0;
      for (var i = 0; i < d.length; i += 16) if (d[i + 3] > 200) { r += d[i]; gr += d[i + 1]; b += d[i + 2]; n++; }
      if (n) k.__rgb = 'rgb(' + Math.round(r / n) + ',' + Math.round(gr / n) + ',' + Math.round(b / n) + ')';
    } catch (e) { k.__rgb = null; }
  }
  function load(src, cb) {
    if (ready[src] === true) { cb(); return; }
    if (ready[src]) return;               /* loading, or failed */
    ready[src] = 'loading';
    var im = new Image();
    im.onload = function () { ready[src] = true; loaded[src] = im; cb(); };
    im.onerror = function () { ready[src] = 'error'; cb(); };
    im.src = src;
  }

  /* ---------- geometry ---------- */
  /* bw×bh = the painting's box (the framed piece must fit in it). st = { m, w, h, crop } */
  function geom(bw, bh, st, minPx) {
    var rx = 0, ry = 0, rw = bw, rh = bh;
    if (st.crop) {
      var rs = st.w / st.h, ri = bw / bh;
      if (rs < ri) { rw = bh * rs; rx = (bw - rw) / 2; } else { rh = bw / rs; ry = (bh - rh) / 2; }
    }
    var k0 = rw / st.w;                         /* px per inch at scale 1 */
    var band0 = (st.m - RABBET) * k0;           /* frame outside the painting edge, at scale 1 */
    var s = Math.min(bw / (rw + 2 * band0), bh / (rh + 2 * band0));
    var t = st.m * k0 * s, r = RABBET * k0 * s;
    if (t < minPx) {                            /* tiny thumbnails: keep the frame readable */
      t = minPx; r = t * RABBET / st.m;
      s = Math.min((bw - 2 * (t - r)) / rw, (bh - 2 * (t - r)) / rh);
    }
    var pw = rw * s, ph = rh * s;
    return {
      rx: rx, ry: ry, rw: rw, rh: rh, s: s, t: t, r: r, pw: pw, ph: ph,
      ow: pw + 2 * (t - r), oh: ph + 2 * (t - r),
      tx: bw / 2 - s * (rx + rw / 2), ty: bh / 2 - s * (ry + rh / 2)
    };
  }
  function scaleFor(t, ow, oh) {
    var F = Math.ceil(100 / Math.max(t, 0.5));
    return Math.max(1, Math.min(F, Math.floor(8000 / Math.max(ow, oh, 1))));
  }
  /* one frame node, laid out F× larger and scaled down */
  function drawFrame(fr, k, src, left, top, ow, oh, t) {
    /* the box sits on whole device pixels: at fractional positions Chrome's compositor snaps the rails and
       loses up to half a pixel of moulding; on the pixel grid the width renders exactly */
    var dpr = window.devicePixelRatio || 1, px = function (v) { return Math.round(v * dpr) / dpr; };
    left = px(left); top = px(top); ow = px(ow); oh = px(oh);
    var F = scaleFor(t, ow, oh);
    /* position through the transform: left/top would be snapped to whole pixels */
    fr.style.left = '0px';
    fr.style.top = '0px';
    fr.style.width = (ow * F) + 'px';
    fr.style.height = (oh * F) + 'px';
    fr.style.transform = 'translate(' + left + 'px,' + top + 'px) scale(' + (1 / F) + ')';
    fr.style.fontSize = (Math.max(ow, oh) * F / 100) + 'px';
    if (src) fr.style.borderImageSource = 'url("' + src + '")';
    fr.style.borderImageSlice = sliceOf(k);
    fr.style.borderImageWidth = (t * F) + 'px';
    fr.style.setProperty('--df-t', (t * F) + 'px');
    fr.setAttribute('data-df-t', t.toFixed(3));
    if (src && loaded[src]) railColour(k, loaded[src]);
    if (k.__rgb) fr.style.setProperty('--df-back', k.__rgb); else fr.style.removeProperty('--df-back');
    fr.hidden = false;
  }

  /* ---------- where frames are drawn ---------- */
  var SITES = [
    { box: '.drehmer__image-container[data-drehmer-open-fullscreen]', img: '.drehmer__image', min: 0 },
    { box: '.drehmer__fullscreen-slide[data-fs-type="main"]', img: '.drehmer__fullscreen-image', min: 0 },
    { box: '.drehmer__fs-room-painting-wrap', img: '.drehmer__fs-room-painting', min: 1 },
    { box: '.drehmer__room-painting-wrap', img: '.drehmer__room-composite-painting', min: 1 },
    { box: '.drehmer__room-thumb-mini-painting-wrap', img: '.drehmer__room-thumb-mini-painting', min: 1 },
    { box: '.drehmer__sticky-img-wrap', img: '.drehmer__sticky-thumb', min: 2 },
    { box: '[data-rv-painting]', img: 'img:not([data-rv-frame-overlay])', min: 1 }
  ];
  function ownFrame(box) {
    for (var i = 0; i < box.children.length; i++) if (box.children[i].classList.contains('drehmer-frame')) return box.children[i];
    return null;
  }
  function childFrame(box) {
    var fr = ownFrame(box);
    if (fr) return fr;
    fr = document.createElement('div');
    fr.className = 'drehmer-frame';
    fr.setAttribute('aria-hidden', 'true');
    fr.hidden = true;
    box.appendChild(fr);
    return fr;
  }
  function siteImg(site, box) {
    var list = box.querySelectorAll(site.img);
    for (var i = 0; i < list.length; i++) if (list[i].parentNode === box) return list[i];
    return null;
  }
  function setImg(img, tf, clip) {
    img.setAttribute('data-df-on', '1');
    img.__dfT = tf; img.__dfClip = clip;
    img.style.transformOrigin = '0 0';
    img.style.transform = tf;
    img.style.clipPath = clip;
  }
  function clearSite(box, img) {
    box.classList.remove('drehmer-frame-on');
    var fr = ownFrame(box);
    if (fr) fr.hidden = true;
    if (img && img.getAttribute('data-df-on')) {
      img.removeAttribute('data-df-on');
      img.__dfT = img.__dfClip = null;
      img.style.transform = '';
      img.style.transformOrigin = '';
      img.style.clipPath = '';
    }
  }
  function paintSite(site, box, st, k) {
    var img = siteImg(site, box);
    if (!img) return;
    if (!st || !k) { clearSite(box, img); return; }
    var bw = img.offsetWidth, bh = img.offsetHeight;
    if (bw < 4 || bh < 4) return;               /* not laid out yet; the ResizeObserver calls back */
    var g = geom(bw, bh, st, site.min);
    var src = kitSrc(k, g.t);
    if (ready[src] !== true) {
      if (ready[src] === 'error') { clearSite(box, img); return; }
      /* swap only once the kit is decoded: keep what is on screen (the section may have reset the transform) */
      if (img.getAttribute('data-df-on') && img.__dfT) { img.style.transformOrigin = '0 0'; img.style.transform = img.__dfT; img.style.clipPath = img.__dfClip || ''; }
      load(src, refresh);
      return;
    }
    setImg(img, 'translate(' + g.tx + 'px,' + g.ty + 'px) scale(' + g.s + ')',
      st.crop ? 'inset(' + g.ry + 'px ' + (bw - g.rx - g.rw) + 'px ' + (bh - g.ry - g.rh) + 'px ' + g.rx + 'px)' : '');
    var fr = childFrame(box);
    drawFrame(fr, k, src, img.offsetLeft + bw / 2 - g.ow / 2, img.offsetTop + bh / 2 - g.oh / 2, g.ow, g.oh, g.t);
    fr.setAttribute('data-df-p', g.pw.toFixed(3));
    fr.setAttribute('data-df-kit', k.slug || '');
    box.classList.add('drehmer-frame-on');
  }

  function current() {
    if (!ctx) return null;
    var card = null;
    try { card = ctx.selected(); } catch (e) { card = null; }
    var k = kitForCard(card);
    if (!k) return null;
    var d = null;
    try { d = ctx.dims(); } catch (e) { d = null; }
    if (d && d[0] > 0 && d[1] > 0) lastDims = d; else d = lastDims;
    if (!d) return null;
    /* the frame always wraps the ordered size's proportions: the photo is cropped to W:H (centre), for standard,
       proportional (rounded) and custom sizes alike; a size that matches the photo crops nothing */
    var crop = true;
    return { kit: k, st: { m: k.moulding_in, w: d[0], h: d[1], crop: crop } };
  }
  function run() {
    queued = false;
    var cur = current();
    SITES.forEach(function (site) {
      var boxes = document.querySelectorAll(site.box);
      for (var i = 0; i < boxes.length; i++) paintSite(site, boxes[i], cur && cur.st, cur && cur.kit);
    });
    menuSync();
  }
  function refresh() {
    if (queued) return;
    queued = true;
    Promise.resolve().then(run);
  }

  /* ---------- corner thumbnails (frame cards, mobile scroller, specs) ----------
     Same scale for every style (8 px per inch of moulding on a 56 px tile), so the thumbnails
     compare the real widths. The painting's own corner sits behind the frame. */
  var PER_IN = 8 / 56, OFFSET = 6 / 56;
  function paintingUrl() {
    var i = document.querySelector('.drehmer__image');
    return i ? (i.currentSrc || i.src || '') : '';
  }
  function cornerIn(host, k) {
    if (!host || !k) return;
    var size = host.clientWidth || parseFloat(getComputedStyle(host).width) || 56;
    var old = host.querySelector(':scope > .drehmer-frame-corner');
    if (old && old.getAttribute('data-df-kit') === k.url && +old.getAttribute('data-df-size') === size) return;
    if (old) old.remove();
    host.querySelectorAll(':scope > img').forEach(function (im) { im.remove(); });
    host.classList.add('drehmer-frame-host');
    var unit = size * PER_IN, off = size * OFFSET;
    var t = k.moulding_in * unit, r = RABBET * unit;
    var wrap = document.createElement('span');
    wrap.className = 'drehmer-frame-corner';
    wrap.setAttribute('aria-hidden', 'true');
    wrap.setAttribute('data-df-kit', k.url);
    wrap.setAttribute('data-df-size', String(size));
    var art = document.createElement('span');
    art.className = 'drehmer-frame-corner__art';
    art.style.left = art.style.top = (off + t - r) + 'px';
    var src = paintingUrl();
    if (src) {
      art.style.backgroundImage = 'url("' + src + '")';
      art.style.backgroundSize = (size * 2.5) + 'px auto';
    }
    var fr = document.createElement('span');
    fr.className = 'drehmer-frame';
    fr.setAttribute('data-df-lazy', '1');
    wrap.appendChild(art);
    wrap.appendChild(fr);
    host.appendChild(wrap);
    var ksrc = kitSrc(k, t);
    /* off-screen thumbnails fetch their kit only when they scroll near the viewport */
    drawFrame(fr, k, io ? null : ksrc, off, off, size * 2, size * 2, t);
    if (io) { fr.__dfSrc = ksrc; io.observe(fr); }
  }
  function cornersAll() {
    document.querySelectorAll('[data-drehmer-frame]').forEach(function (card) {
      if (card.hasAttribute('data-frame-style-slug')) return;   /* catalog cards carry the corner photo */
      var k = kitForCard(card);
      if (!k) return;
      cornerIn(card.querySelector('.drehmer__frame-thumb'), k);
    });
    document.querySelectorAll('[data-drehmer-mfs] .dropdown-item[data-mfs-frame-id]').forEach(function (it) {
      if (it.hasAttribute('data-mfs-frame-slug')) return;
      var card = document.querySelector('[data-drehmer-frame="' + it.getAttribute('data-mfs-frame-id') + '"]');
      var k = kitForCard(card);
      if (k) cornerIn(it.querySelector('.dropdown-image'), k);
    });
  }
  function cornerSpecs() {
    var body = document.querySelector('[data-drehmer-frame-specs-body]');
    if (!body || !ctx) return;
    var card = null;
    try { card = ctx.selected(); } catch (e) { card = null; }
    if (!card || card.hasAttribute('data-frame-style-slug')) return;
    var k = kitForCard(card);
    if (k) cornerIn(body.querySelector('.drehmer__frame-specs-thumb'), k);
  }

  /* real moulding width on every card (the section's specs read data-frame-width) */
  function widthsAll() {
    document.querySelectorAll('[data-drehmer-frame]').forEach(function (card) {
      var k = kitForCard(card);
      if (!k || card.hasAttribute('data-frame-width')) return;
      var m = k.moulding_in;
      card.setAttribute('data-frame-width', m + "'' inches 📏 " + (m * 2.54).toFixed(1) + ' cm');
    });
  }

  /* ---------- the frame menu, driven by the B2B catalog ----------
     Built when this deferred script runs, i.e. before the section's DOMContentLoaded handler binds the
     frame / scroller clicks. One card per catalog frame per frame band; the price comes from the variant of
     the frame's price_style in that band (all catalog frames cost the same per band). */
  function esc(v) { return String(v == null ? '' : v).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function handle(v) { return String(v || '').toLowerCase().replace(/['’]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
  function money(cents) {
    var parts = (Math.round(cents) / 100).toFixed(2).split('.');
    return '$' + parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + (parts[1] === '00' ? '' : '.' + parts[1]);
  }
  function el(tag, cls, attrs, html) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (attrs) Object.keys(attrs).forEach(function (a) { if (attrs[a] != null) e.setAttribute(a, attrs[a]); });
    if (html != null) e.innerHTML = html;
    return e;
  }
  function inches(cm) { return Math.round(cm / 2.54 * 10) / 10; }
  function sizeText(f) {
    var w = +f.width_cm, t = +f.thickness_cm;
    if (!(w > 0)) return '';
    return t > 0 ? (w + ' × ' + t + ' cm (' + inches(w) + ' × ' + inches(t) + ' in)') : (w + ' cm (' + inches(w) + ' in)');
  }
  function priceOptions() {
    var map = {};
    document.querySelectorAll('select.bundle-variants option[value]').forEach(function (o) {
      if (!o.value) return;
      var t = o.getAttribute('data-frame-type') || '', b = o.getAttribute('data-size') || '';
      (map[t] = map[t] || { bands: [], by: {} });
      if (!map[t].by[b]) { map[t].by[b] = o; map[t].bands.push(b); }
    });
    return map;
  }
  function cardAttrs(f, o, band) {
    return {
      'type': 'button',
      'data-drehmer-frame': o.value,
      'data-frame-size': band,
      'data-frame-price': o.getAttribute('data-frame-price'),
      'data-frame-price-cents': o.getAttribute('data-frame-price-cents'),
      'data-frame-name': f.name,
      'data-frame-style-slug': f.slug,
      'data-frame-num': f.num || '',
      'data-frame-image': thumbOf(f),
      'data-frame-cover': thumbOf(f),
      'data-frame-width': f.width_cm ? (f.width_cm + ' cm') : null,
      'data-frame-thickness': f.thickness_cm ? (f.thickness_cm + ' cm') : null
    };
  }
  /* corner photos (400 px transparent PNG): a 300 px CDN copy covers the ~90 px tile at 2× */
  function thumbSrc(u) {
    if (!u || !/\/cdn\/shop\/|cdn\.shopify\.com/.test(u)) return u;
    return u + (u.indexOf('?') < 0 ? '?' : '&') + 'width=300';
  }
  function thumbOf(f) { return f.thumb_url || (/^(https?:)?\/\//.test(f.thumb || '') ? f.thumb : ''); }
  /* later = the swatches of the closed Framed panel: the URL waits in data-df-src until the panel is about to
     open (menuThumbs), because a lazy <img> inside the 0-height panel still loads on page load (11 files) */
  function thumbImg(f, size, later) {
    var u = thumbOf(f);
    return u ? '<img class="drehmer-frame-thumb-img" ' + (later ? 'data-df-src' : 'src') + '="' + esc(thumbSrc(u)) + '" alt="" loading="lazy" decoding="async" width="' + size + '" height="' + size + '">' : '';
  }
  function tileImg(u, flat, eager) {
    return '<img class="drehmer-frame-thumb-img' + (flat ? ' drehmer-frame-thumb-img--flat' : '') + '" src="' + esc(u) + '" alt=""' + (eager ? '' : ' loading="lazy"') + ' decoding="async" width="92" height="92">';
  }
  /* v15 (Louie 23/10): the Framed tile shows the painting itself in the frame's opening, so its price reads as
     painting + frame. thumb_open = where the corner photo's transparent opening starts (share of its side). */
  function framedGlimpse(f) {
    var src = paintingUrl(), at = +f.thumb_open;
    if (!src || !(at > 0 && at < 1)) return '';
    var edge = Math.max(0, at * 100 - 2).toFixed(1) + '%';
    return '<span class="drehmer-frame-glimpse" aria-hidden="true" style="left:' + edge + ';top:' + edge + ';background-image:url(&quot;' + esc(src) + '&quot;)"></span>';
  }
  /* a click made by this script must not trigger the section's mobile "scroll to the painting" */
  function quietClick(b) {
    var keep = window.scrollTo;
    window.scrollTo = function () {};
    try { b.click(); } finally { window.scrollTo = keep; }
  }
  var menu = null;         /* { grid, framed, list, expanded } */
  /* Delivery row = [Framed ⌄] [Gallery Wrap] [Unframed]. "Framed" opens the catalog list below the row
     (full width), picking the first frame when none is chosen; Gallery Wrap / Unframed close it. */
  function buildMenu() {
    if (!catalog) return false;
    var grid = document.querySelector('[data-drehmer-delivery-grid]');
    var opts = priceOptions();
    var usable = catalog.filter(function (f) { return opts[handle(f.price_style)]; });
    if (!grid || !usable.length) return false;
    var sizeSel = document.querySelector('[data-drehmer-size].is-selected');
    var curBand = sizeSel ? (sizeSel.getAttribute('data-frame-band') || sizeSel.getAttribute('data-inch') || '') : '';
    var art = sizeSel ? (parseInt(sizeSel.getAttribute('data-price'), 10) || 0) : 0;

    grid.querySelectorAll('[data-drehmer-frame], [data-drehmer-frame-toggle]').forEach(function (c) { c.remove(); });
    grid.classList.add('drehmer-frame-menu');
    var card0 = grid.closest('.drehmer__delivery'); if (card0) card0.classList.add('drehmer-frame-menu-card');
    var mfsWrap = document.querySelector('.drehmer-mfs-wrap'); if (mfsWrap) mfsWrap.classList.add('drehmer-frame-menu-off');
    var gw = grid.querySelector('[data-drehmer-delivery="stretched"]');
    var unf = grid.querySelector('[data-drehmer-delivery="unframed"]');

    var framed = grid.querySelector('[data-drehmer-frame-menu]');
    if (!framed) {
      framed = el('button', 'drehmer__delivery-option drehmer-frame-framed', { 'type': 'button', 'aria-expanded': 'false', 'aria-controls': 'drehmer-frame-list', 'data-drehmer-frame-menu': '' },
        '<div class="drehmer__delivery-tile-badge">Recommended</div><div class="drehmer__delivery-tile-img drehmer-frame-thumb" data-df-framed-thumb></div>' +
        '<div class="drehmer__delivery-tile-label">Framed<svg class="drehmer-frame-chev" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="6 9 12 15 18 9"></polyline></svg></div>' +
        '<div class="drehmer-bundle__total" data-df-framed-total></div><div class="drehmer__delivery-tile-desc">Ready to hang</div>');
      grid.insertBefore(framed, gw || unf || grid.firstChild);
    }
    /* Gallery Wrap and Unframed: the same thumb box as the frames (catalog images when present) */
    [[gw, extras.wrap_thumb_url], [unf, extras.unframed_thumb_url]].forEach(function (pair) {
      var box = pair[0] && pair[0].querySelector('.drehmer__delivery-tile-img');
      if (!box) return;
      box.classList.add('drehmer-frame-thumb');
      var old = box.querySelector('img');
      if (pair[1]) box.innerHTML = tileImg(thumbSrc(pair[1]), false, true);
      else if (old) {
        old.classList.add('drehmer-frame-thumb-img', 'drehmer-frame-thumb-img--flat');
        old.setAttribute('src', old.getAttribute('src').replace(/([?&]width=)\d+/, '$1300'));
      }
    });

    /* the panel "inside" Framed: a header (Frame: <name>) and the swatches, a radio group.
       Each swatch is a [data-drehmer-frame] button, so the section's frame logic drives it; the hidden total
       only carries the band price for the Framed card. */
    var panel = el('div', 'drehmer-frame-panel', { 'id': 'drehmer-frame-list' });
    panel.innerHTML = '<div class="drehmer-frame-panel__clip"><div class="drehmer-frame-panel__body">' +
      '<p class="drehmer-frame-panel__head" id="drehmer-frame-panel-head"><span class="drehmer-frame-panel__label">Frame:</span> <span data-df-panel-name></span></p>' +
      '<div class="drehmer-frame-panel__grid" role="radiogroup" aria-labelledby="drehmer-frame-panel-head"></div></div></div>';
    var list = panel.querySelector('.drehmer-frame-panel__grid');
    usable.forEach(function (f) {
      var po = opts[handle(f.price_style)];
      po.bands.forEach(function (band) {
        var o = po.by[band];
        var cents = parseInt(o.getAttribute('data-frame-price-cents'), 10) || 0;
        var at = cardAttrs(f, o, band);
        at['role'] = 'radio'; at['aria-checked'] = 'false'; at['tabindex'] = '-1';
        list.appendChild(el('button', 'drehmer-frame-swatch' + (band !== curBand ? ' drehmer__frame-card--size-hidden' : ''), at,
          '<span class="drehmer-frame-swatch__thumb">' + thumbImg(f, 72, true) + '</span>' +
          '<span class="drehmer-frame-swatch__name drehmer__frame-card-name">' + esc(f.short || f.name) + '</span>' +
          '<span class="drehmer-bundle__total" hidden>' + money(art + cents) + '</span>'));
      });
    });
    /* right after the grid (not inside it), so a closed panel adds no grid gap */
    grid.parentNode.insertBefore(panel, grid.nextSibling);
    /* arrow keys move the choice inside the group (the painting follows, like a click) */
    list.addEventListener('keydown', function (e) {
      var step = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
      if (!step && e.key !== 'Home' && e.key !== 'End') return;
      var items = [].filter.call(list.querySelectorAll('[data-drehmer-frame]'), function (x) { return !x.classList.contains('drehmer__frame-card--size-hidden'); });
      if (!items.length) return;
      var i = items.indexOf(document.activeElement);
      var n = e.key === 'Home' ? 0 : e.key === 'End' ? items.length - 1 : ((i < 0 ? 0 : i) + step + items.length) % items.length;
      e.preventDefault();
      quietClick(items[n]);
      items[n].focus();
    });
    menu = { grid: grid, framed: framed, panel: panel, list: list, expanded: false };

    /* the corner photos start loading as soon as the pointer or the focus reaches Framed, so the panel opens full */
    framed.addEventListener('pointerenter', menuThumbs);
    framed.addEventListener('focus', menuThumbs);
    framed.addEventListener('click', function () {
      var sel = selectedCard();
      if (!sel) {
        menu.expanded = true;
        var first = list.querySelector('[data-drehmer-frame]:not(.drehmer__frame-card--size-hidden)');
        if (first) quietClick(first);
      } else {
        menu.expanded = !menu.expanded;
      }
      menuSync();
    });

    /* the framing-info modal: the catalog count, no price claim (every frame costs the same per size) */
    document.querySelectorAll('.drehmer__framing-option p').forEach(function (pp) {
      if (/different styles in our catalog/.test(pp.textContent)) pp.textContent = 'Comes with a frame already chosen and applied. You can select from ' + usable.length + ' frame styles in our catalog.';
    });
    menuSync();
    return true;
  }
  function menuThumbs() {
    if (!menu || menu.loaded) return;
    menu.loaded = true;
    menu.list.querySelectorAll('img[data-df-src]').forEach(function (im) {
      im.loading = 'eager';
      im.src = im.getAttribute('data-df-src');
      im.removeAttribute('data-df-src');
    });
  }
  function selectedCard() {
    if (!ctx) return null;
    try { return ctx.selected(); } catch (e) { return null; }
  }
  /* the Framed card shows the chosen frame (or the first of the list): its thumb and total; the panel header names it */
  function menuSync() {
    if (!menu) return;
    var sel = selectedCard();
    if (!sel) menu.expanded = false;
    menu.panel.classList.toggle('is-open', menu.expanded);
    /* first opening: fetch every corner photo now (11 small files) */
    if (menu.expanded) menuThumbs();
    menu.framed.setAttribute('aria-expanded', menu.expanded ? 'true' : 'false');
    menu.framed.classList.toggle('is-open', menu.expanded);
    menu.framed.classList.toggle('is-selected', !!sel);
    var first = menu.list.querySelector('[data-drehmer-frame]:not(.drehmer__frame-card--size-hidden)');
    var ref = (sel && menu.list.contains(sel)) ? sel : first;
    /* roving tabindex: the checked swatch (else the first one) is the group's tab stop */
    menu.list.querySelectorAll('[data-drehmer-frame]').forEach(function (c) {
      c.setAttribute('aria-checked', c === sel ? 'true' : 'false');
      c.setAttribute('tabindex', c === ref ? '0' : '-1');
    });
    var f = ref ? bySlug[ref.getAttribute('data-frame-style-slug') || ''] : null;
    var tot = menu.framed.querySelector('[data-df-framed-total]');
    var th = menu.framed.querySelector('[data-df-framed-thumb]');
    var hd = menu.panel.querySelector('[data-df-panel-name]');
    if (tot) { var t = ref && ref.querySelector('.drehmer-bundle__total'); tot.textContent = t ? t.textContent : ''; }
    if (hd) hd.textContent = f ? (f.short || f.name) : '';
    if (th && f) {
      var u = thumbSrc(thumbOf(f));
      var g = u ? framedGlimpse(f) : '', key = u + (g ? '#glimpse' : '');
      if (th.getAttribute('data-src') !== key) { th.setAttribute('data-src', key); th.innerHTML = u ? g + tileImg(u, false, true) : ''; }
    }
  }

  /* Frame Specifications for a catalog frame (the section calls this from updateFrameSpecs) */
  function specs(card, dims) {
    readKits();
    var f = card ? bySlug[card.getAttribute('data-frame-style-slug') || ''] : null;
    if (!f) return null;
    var row = function (k, v) { return '<div class="drehmer__frame-specs-row"><span class="drehmer__frame-specs-label">' + k + '</span><span class="drehmer__frame-specs-value">' + v + '</span></div>'; };
    var html = '<div class="drehmer__frame-specs-info drehmer__frame-specs-info--with-image">';
    if (thumbOf(f)) html += '<div class="drehmer__frame-specs-thumb drehmer-frame-thumb">' + thumbImg(f, 80) + '</div>';
    html += '<div class="drehmer__frame-specs-rows">';
    html += row('Frame', esc(f.short || f.label || f.name));
    html += row('Style', esc(f.name) + (f.desc ? ' · ' + esc(f.desc) : ''));
    var sz = sizeText(f);
    if (sz) html += row(+f.thickness_cm > 0 ? 'Width × thickness' : 'Width', sz);
    var m = +f.width_cm > 0 ? f.width_cm / 2.54 : f.moulding_in;
    if (dims && m > 0) {
      html += row('Made to fit', dims[0] + ' × ' + dims[1] + ' in');
      html += row('Overall size with frame', (dims[0] + 2 * m).toFixed(1) + ' × ' + (dims[1] + 2 * m).toFixed(1) + ' in');
    }
    html += row('Information', 'Your framed oil painting is ready to hang right out of the box. We take care of the stretching, mounting, and include wall hooks, so you can admire your artwork as soon as it arrives.');
    return html + '</div></div>';
  }

  /* ---------- screen readers: the choices say which one is chosen ----------
     Size cards, inch/cm and the delivery options are plain buttons whose choice is a class (is-selected /
     is-active), set from many places in the section. aria-pressed mirrors that class, so "M, pressed" is
     announced; the custom-size message and price are read when they change. */
  function pressedSync(b) {
    var on = b.classList.contains(b.hasAttribute('data-drehmer-unit') ? 'is-active' : 'is-selected') ? 'true' : 'false';
    if (b.getAttribute('aria-pressed') !== on) b.setAttribute('aria-pressed', on);
  }
  function a11y() {
    var sel = '.drehmer [data-drehmer-size], .drehmer [data-drehmer-unit], .drehmer [data-drehmer-delivery], .drehmer [data-drehmer-frame-menu]';
    var mo = ('MutationObserver' in window) ? new MutationObserver(function (list) {
      list.forEach(function (m) { pressedSync(m.target); });
    }) : null;
    document.querySelectorAll(sel).forEach(function (b) {
      if (b.tagName !== 'BUTTON') return;
      pressedSync(b);
      if (mo) mo.observe(b, { attributes: true, attributeFilter: ['class'] });
    });
    document.querySelectorAll('.drehmer [data-custom-msg], .drehmer [data-custom-price]').forEach(function (n) {
      if (!n.hasAttribute('aria-live')) n.setAttribute('aria-live', 'polite');
    });
  }

  function init() {
    readKits();
    if (!Object.keys(kits).length && !catalog) { try { a11y(); } catch (e) {} return; }
    buildMenu();
    /* after buildMenu, which may create the Framed card; a failure here never blocks the frames */
    try { a11y(); } catch (e) {}
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var fr = en.target;
          if (fr.__dfSrc) fr.style.borderImageSource = 'url("' + fr.__dfSrc + '")';
          io.unobserve(fr);
        });
      }, { rootMargin: '600px 0px' });
    }
    widthsAll();
    cornersAll();
    if ('ResizeObserver' in window) {
      ro = new ResizeObserver(refresh);
      SITES.forEach(function (site) {
        document.querySelectorAll(site.box).forEach(function (box) {
          var img = siteImg(site, box);
          if (img) ro.observe(img);
        });
      });
    } else {
      window.addEventListener('resize', refresh);
    }
    var body = document.querySelector('[data-drehmer-frame-specs-body]');
    if (body && 'MutationObserver' in window) new MutationObserver(cornerSpecs).observe(body, { childList: true });
    cornerSpecs();
    refresh();
  }

  window.DrehmerFrame = {
    /* ctx = { selected(): frame card | null, dims(): [w_in, h_in] | null, cropped(): bool } */
    bind: function (c) { ctx = c; refresh(); },
    has: function (name) { return !!kitFor(name); },
    lip: function (name) { return kitFor(name) ? RABBET : 0; },
    specs: specs,
    refresh: refresh,
    _geom: geom
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
